export default {
    type: 'widget',
    config: {
        minWidth: {
            desktop: 200,
            mobile: 120
        },
        align: 'left'
    },
    default: {
        label: 'Game'
    },
    sort: 'name',
    unique: [
        {
            key: 'version',
            type: 'checklist',
            default: 'enabled',
            name: 'Version',
            contexts: ['collection'],
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show version',
                    description: 'Show version name if exists.'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide version',
                    description: 'Don\'t show vesion name if exists.'
                }
            ]
        },
        {
            key: 'tags',
            type: 'checklist',
            default: 'enabled',
            name: 'Tags',
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show tags',
                    description: 'Show any applicable tags'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide tags',
                    description: 'Don\'t show any applicable tags.'
                }
            ]
        },
        {
            key: 'awards',
            type: 'checklist',
            default: 'enabled',
            name: 'Highlights',
            contexts: ['gameplays'],
            views: ['grid'],
            options: [
                {
                    value: 'enabled',
                    text: 'Enabled',
                    preview: 'Show highlights',
                    description: 'Show any player stat highlights (e.g. most played with)'
                },
                {
                    value: 'disabled',
                    text: 'Disabled',
                    preview: 'Hide highlights',
                    description: 'Don\'t show any player stat highlights'
                }
            ]
        }
    ],
    lang: {
        name: 'Game Info',
        views: ['list'],
        category: 'Game',
        description: 'Summary of game with optional such as name, version, tags, and stuff.'
    }
}